import React from 'react';
import {
  ModalFloatingCloseBtn,
  useBreakpointHelpers,
} from '@sweetgreen/garnish';

import {
  AddressForm,
  LoadingAnimation,
  PageWrapper,
  TransparentModal,
  useAddressHandlers,
} from '@order/components';
import { useCustomer } from '@order/Customer';
import { useLocalizationContext } from '@order/Localization';

import { useNavigateBack } from '../../navigation';

export const AddressAddScreen = () => {
  const { t } = useLocalizationContext();
  const { isCustomerLoaded } = useCustomer();

  const handleGoBack = useNavigateBack();

  const { isAddingAddress, handleOnSave, handleOnEdit, handleOnDelete } =
    useAddressHandlers({ checkExistingBag: true, onClose: handleGoBack });

  const { isMobile } = useBreakpointHelpers();

  if (!isCustomerLoaded) return <LoadingAnimation />;

  return (
    <TransparentModal size="small" onClose={handleGoBack}>
      {isMobile ? null : <ModalFloatingCloseBtn onPress={handleGoBack} />}
      <PageWrapper
        withHeaderTitle
        withoutFooter
        testID="account.add-address.root.container"
      >
        <AddressForm
          address={undefined}
          visible={true}
          editing={false}
          loading={isAddingAddress}
          deleting={false}
          noHeader={false}
          disableAddress={false}
          submitCta={t('account.addresses.save')}
          onSave={handleOnSave}
          onEdit={handleOnEdit}
          onDelete={handleOnDelete}
        />
      </PageWrapper>
    </TransparentModal>
  );
};
